import { Routes, Route } from 'react-router-dom';
import {variables} from './Component/Variables';
 
import { useEffect } from "react"
 
//Arabic Part Coins Arabic Component
import Arabic  from "./Component/Arabic"
import Most_View_Ar  from "./Component/Most_View_Ar"

import News_Page_Ar  from "./Component/News_Page_Ar"
import OurLatest_News_Ar  from "./Component/OurLatest_News_Ar"

import CryptoAr  from "./Component/CryptoAr"
import EconomyAr  from "./Component/EconomyAr"
import PressReleaseAr  from "./Component/PressReleaseAr"
import MarketResearchAr  from "./Component/MarketResearchAr"
import ReportsAr  from "./Component/ReportsAr"

import TrendingNewsCoins_Ar  from "./Component/TrendingNewsCoins_Ar"
import TrendingList_Ar  from "./Component/TrendingList_Ar"
import TrendingList_Ar2  from "./Component/TrendingList_Ar2"
import NewFeature_Ar  from "./Component/NewFeature_Ar"
import ListMainArticle_Ar  from "./Component/ListMainArticle_Ar"
import MainArticle_Ar  from "./Component/MainArticle_Ar"
import SmallArticle_Ar  from "./Component/SmallArticle_Ar"

import TrendyPage_AR  from "./Component/TrendyPage_AR"
 import Latest_Ar  from "./Component/Latest_Ar"
 import Popular_Ar  from "./Component/Popular_Ar"

 import SportList_Ar  from "./Component/SportList_Ar"
 import MainSportList_Ar  from "./Component/MainSportList_Ar"

 import WhatsnewHome_Ar  from "./Component/WhatsnewHome_Ar"

//

export default function App( ) {
   
  return (
    
    
    <div className="App">
  
 

    <Routes>
    
  
    <Route path ={ variables.basename + "/TrendingNewsCoins_Ar"} element={<TrendingNewsCoins_Ar/>} /> 
    <Route path ="http://coinsinsight.com/arabic/TrendingNewsCoins_Ar" element={<TrendingNewsCoins_Ar/>} />
    <Route path ={   "/arabic/TrendingNewsCoins_Ar"} element={<TrendingNewsCoins_Ar/>} /> 

    <Route path ={ variables.basename + "/TrendingList_Ar"} element={<TrendingList_Ar/>} /> 
    <Route path ="http://coinsinsight.com/arabic/TrendingList_Ar" element={<TrendingList_Ar/>} />
    <Route path ={   "/arabic/TrendingList_Ar"} element={<TrendingList_Ar/>} /> 
   
    
    <Route path ={ variables.basename + "/NewFeature_Ar"} element={<NewFeature_Ar/>} /> 
    <Route path ="http://coinsinsight.com/arabic/NewFeature_Ar" element={<NewFeature_Ar/>} />
    <Route path ={   "/arabic/NewFeature_Ar"} element={<NewFeature_Ar/>} /> 
  
   
    <Route path ={ variables.basename + "/ListMainArticle_Ar"} element={<ListMainArticle_Ar/>} /> 
    <Route path ="http://coinsinsight.com/arabic/ListMainArticle_Ar" element={<ListMainArticle_Ar/>} />
    <Route path ={   "/arabic/ListMainArticle_Ar"} element={<ListMainArticle_Ar/>} /> 
    
    <Route path ={ variables.basename + "/MainArticle_Ar"} element={<MainArticle_Ar/>} /> 
    <Route path ="http://coinsinsight.com/arabic/MainArticle_Ar" element={<MainArticle_Ar/>} />
    <Route path ={   "/arabic/MainArticle_Ar"} element={<MainArticle_Ar/>} /> 

    <Route path ={ variables.basename + "/SmallArticle_Ar"} element={<SmallArticle_Ar/>} /> 
    <Route path ="http://coinsinsight.com/arabic/SmallArticle_Ar" element={<SmallArticle_Ar/>} />
    <Route path ={   "/arabic/SmallArticle_Ar"} element={<SmallArticle_Ar/>} /> 
  
    <Route path ={ variables.basename + "/TrendyPage_AR"} element={<TrendyPage_AR/>} /> 
    <Route path ="http://coinsinsight.com/arabic/TrendyPage_AR" element={<TrendyPage_AR/>} />
    <Route path ={   "/arabic/TrendyPage_AR"} element={<TrendyPage_AR/>} /> 
    
    <Route path ={ variables.basename + "/Latest_Ar"} element={<Latest_Ar/>} /> 
    <Route path ="http://coinsinsight.com/arabic/Latest_Ar" element={<Latest_Ar/>} />
    <Route path ={   "/arabic/Latest_Ar"} element={<Latest_Ar/>} /> 

    <Route path ={ variables.basename + "/Popular_Ar"} element={<Popular_Ar/>} /> 
    <Route path ="http://coinsinsight.com/arabic/Popular_Ar" element={<Popular_Ar/>} />
    <Route path ={   "/arabic/Popular_Ar"} element={<Popular_Ar/>} /> 
    

    <Route path ={ variables.basename + "/SportList_Ar"} element={<SportList_Ar/>} /> 
    <Route path ="http://coinsinsight.com/arabic/SportList_Ar" element={<SportList_Ar/>} />
    <Route path ={   "/arabic/SportList_Ar"} element={<SportList_Ar/>} /> 
    
    <Route path ={ variables.basename + "/MainSportList_Ar"} element={<MainSportList_Ar/>} /> 
    <Route path ="http://coinsinsight.com/arabic/MainSportList_Ar" element={<MainSportList_Ar/>} />
    <Route path ={   "/arabic/MainSportList_Ar"} element={<MainSportList_Ar/>} /> 


    <Route path ={ variables.basename + "/WhatsnewHome_Ar"} element={<WhatsnewHome_Ar/>} /> 
    <Route path ="http://coinsinsight.com/arabic/WhatsnewHome_Ar" element={<WhatsnewHome_Ar/>} />
    <Route path ={   "/arabic/WhatsnewHome_Ar"} element={<WhatsnewHome_Ar/>} /> 
    
    <Route path ={ variables.basename + "/TrendingList_Ar2"} element={<TrendingList_Ar2/>} /> 
    <Route path ="http://coinsinsight.com/arabic/TrendingList_Ar2" element={<TrendingList_Ar2/>} />
    <Route path ={   "/arabic/TrendingList_Ar2"} element={<TrendingList_Ar2/>} /> 
    
  


    <Route path ={ variables.basename + "/Most_View_Ar"} element={<Most_View_Ar/>} /> 
    <Route path ="http://coinsinsight.com/arabic/Most_View_Ar" element={<Most_View_Ar/>} />
    <Route path ={   "/arabic/Most_View_Ar"} element={<Most_View_Ar/>} /> 
   

    
<Route path=  {  "/arabic/:storyID/:title"}    element={<News_Page_Ar/>} />
 <Route path=  { variables.basename + "/arabic/:storyID/:title"}    element={<News_Page_Ar/>} />
 <Route path=  { variables.basename + "/news_page/:storyID/:title"}    element={<News_Page_Ar/>} />      
 <Route path=  {   "/arabic/:storyID/:title"}    element={<News_Page_Ar/>} />

    
    <Route path ={ variables.basename + "/OurLatest_News_Ar"} element={<OurLatest_News_Ar/>} /> 
    <Route path ="http://coinsinsight.com/arabic/OurLatest_News_Ar" element={<OurLatest_News_Ar/>} />
    <Route path ={   "/arabic/OurLatest_News_Ar"} element={<OurLatest_News_Ar/>} /> 
    
    {/* CoinsInsight Arabic */}
    <Route path ={ variables.basename + "/OurLatest_News_Ar"} element={<OurLatest_News_Ar/>} /> 
    <Route path ="http://coinsinsight.com/arabic/OurLatest_News_Ar" element={<OurLatest_News_Ar/>} />
    <Route path ={   "/arabic/OurLatest_News_Ar"} element={<OurLatest_News_Ar/>} /> 
   
    <Route path ={ variables.basename + "/CryptoAr"} element={<CryptoAr/>} /> 
    <Route path ="http://coinsinsight.com/arabic/CryptoAr" element={<CryptoAr/>} />
    <Route path ={   "/arabic/CryptoAr"} element={<CryptoAr/>} /> 

    <Route path ={ variables.basename + "/EconomyAr"} element={<EconomyAr/>} /> 
    <Route path ="http://coinsinsight.com/arabic/EconomyAr" element={<EconomyAr/>} />
    <Route path ={   "/arabic/EconomyAr"} element={<EconomyAr/>} /> 


    <Route path ={ variables.basename + "/PressReleaseAr"} element={<PressReleaseAr/>} /> 
    <Route path ="http://coinsinsight.com/arabic/PressReleaseAr" element={<PressReleaseAr/>} />
    <Route path ={   "/arabic/PressReleaseAr"} element={<PressReleaseAr/>} /> 
     
    <Route path ={ variables.basename + "/MarketResearchAr"} element={<MarketResearchAr/>} /> 
    <Route path ="http://coinsinsight.com/arabic/MarketResearchAr" element={<MarketResearchAr/>} />
    <Route path ={   "/arabic/MarketResearchAr"} element={<MarketResearchAr/>} /> 
    
    <Route path ={ variables.basename + "/ReportsAr"} element={<ReportsAr/>} /> 
    <Route path ="http://coinsinsight.com/arabic/ReportsAr" element={<ReportsAr/>} />
    <Route path ={   "/arabic/ReportsAr"} element={<ReportsAr/>} /> 
    
    <Route path ={ variables.basename + "/Arabic"} element={<Arabic/>} /> 
    <Route path ="http://coinsinsight.com/Arabic/Arabic" element={<Arabic/>} />
    <Route path ={   "/arabic/Arabic"} element={<Arabic/>} /> 

    </Routes>
    </div>

    
    
  );
}
